export default {
  path: '/style',
  title: '云版房',
  children: [
    {
      //   path: 'home',
      //   title: '首页',
      //   icon: 'home',
      //   component: 'style/home'
      // }, {
      path: 'measure',
      title: '量体数据',
      icon: 'male',
      children: [
        {
          path: 'measureClassify',
          title: '量体分类',
          component: 'style/measure/measureClassify'
        },
        {
          path: 'measureItem',
          title: '量体项',
          component: 'style/measure/measureItem'
        },
        {
          path: 'measureItemClassify',
          title: '品类量体项',
          component: 'style/measure/measureItemClassify'
        },
        {
          path: 'measureItemVerify',
          title: '品类量体校验',
          component: 'style/measure/measureItemVerify'
        },
        {
          path: 'bodyLanguageGroup',
          title: '身体语言组',
          component: 'style/measure/bodyLanguageGroup'
        },
        {
          path: 'bodyLanguage',
          title: '身体语言',
          component: 'style/measure/bodyLanguage'
        },
        {
          path: 'bodyLanguageClassify',
          title: '品类身体语言',
          component: 'style/measure/bodyLanguageClassify'
        }
      ]
    },
    {
      path: 'color',
      title: '颜色管理',
      icon: 'dashboard',
      component: 'style/color'
    },
    {
      path: 'size',
      title: '尺码管理',
      icon: 'th',
      component: 'style/size'
    },
    {
      path: 'style',
      title: '版型风格',
      icon: 'female',
      component: 'style/style'
    },
    {
      path: 'commodity',
      title: '商品管理',
      icon: 'shopping-bag',
      children: [
        {
          path: 'spot',
          title: '大货商品',
          component: 'style/commodity/spot'
        },
        {
          path: 'customize',
          title: '定制商品',
          component: 'style/commodity/customize'
        }
      ]
    },
    {
      path: 'material',
      title: '物料管理',
      icon: 'cubes',
      children: [
        {
          path: 'materialClassify',
          title: '物料分类',
          component: 'style/material/materialClassify'
        },
        {
          path: 'materialPart',
          title: '物料部位',
          component: 'style/material/materialPart'
        }
      ]
    },
    {
      path: 'cad',
      title: 'CAD管理',
      icon: 'tasks',
      children: [
        {
          path: 'cadPart',
          title: 'CAD部位',
          component: 'style/cad/cadPart'
        }
      ]
    },
    {
      path: 'match',
      title: '版型匹配',
      icon: 'bar-chart',
      children: [
        {
          path: 'codeRules',
          title: '编码规则',
          component: 'style/match/codeRules'
        },
        {
          path: 'partRules',
          title: '部位规则',
          component: 'style/match/partRules'
        },
        {
          path: 'styleRules',
          title: '版型匹配',
          component: 'style/match/styleRules'
        },
        {
          path: 'materialBom',
          title: '物料BOM',
          component: 'style/match/materialBom'
        },
        {
          path: 'cadSize',
          title: 'CAD尺寸',
          component: 'style/match/cadSize'
        },
        {
          path: 'styleFile',
          title: '版型文件',
          component: 'style/match/styleFile'
        },
        {
          path: 'stylePreview',
          title: '版型预览',
          component: 'style/match/stylePreview'
        }
      ]
    },
    {
      path: 'warehouse',
      title: '库位管理',
      icon: 'sitemap',
      children: [
        {
          path: 'manage',
          title: '库位管理',
          component: 'style/warehouse/manage'
        },
        {
          path: 'color',
          title: '版型文件',
          component: 'style/warehouse/color'
        },
        {
          path: 'distribute',
          title: '版型分配',
          component: 'style/warehouse/distribute'
        }
      ]
    },
    {
      path: 'intelligent',
      title: '智能量体',
      icon: 'superpowers',
      children: [
        {
          path: 'brand',
          title: '品牌管理',
          component: 'style/intelligent/brand'
        },
        {
          path: 'item',
          title: '匹配项',
          component: 'style/intelligent/item'
        },
        {
          path: 'match',
          title: '智能匹配',
          component: 'style/intelligent/match'
        }
      ]
    },
    {
      path: 'craftsLibrary',
      title: '工艺库',
      icon: 'sticky-note',
      component: 'style/craftsLibrary'
    }
  ]
}
